<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last">
      <ng-container *ngIf="last; else notLast">
        <strong *tuiItem tuiFade>{{ item.label }}</strong>
      </ng-container>
      <ng-template #notLast>
        <button *tuiItem tuiLink type="button" (click)="navigate(item.link)" [disabled]="!item.link">
          {{ item.label }}
        </button>
      </ng-template>
    </ng-container>
  </tui-breadcrumbs>
</nav>

<section class="w-full max-w-2xl mt-6">
  <p class="text-3xl font-normal mt-0 mb-2">Admin Control</p>
  <p class="text-sm text-[#64748B] mt-0 mb-8">
    Maintenance tools. This page is not linked in the navigation — open via
    <code>/admin/admincontrol</code>.
  </p>

  <div class="sync-card">
    <p class="text-base font-medium text-[#3E4A58] my-0">Sync nurse casual IDs</p>
    <p class="text-sm text-[#949494] mt-2 mb-4">
      Rewrites legacy <b>NURSE-#####</b> values to <b>CID-#####</b> (same digits).
      Nurses marked as manually edited are skipped. Safe to run more than once.
    </p>
    <button
      tuiButton
      type="button"
      appearance="primary"
      size="m"
      [disabled]="syncing"
      (click)="syncNurseCasualIds()"
    >
      {{ syncing ? "Syncing…" : "Sync nurse casual IDs" }}
    </button>

    <tui-loader *ngIf="syncing" class="block mt-4" [showLoader]="true" />

    <div *ngIf="result" class="result mt-4 text-sm text-[#334155]">
      <p class="my-1"><b>Migrated:</b> {{ result.migrated }}</p>
      <p class="my-1"><b>Already CID-:</b> {{ result.alreadyCanonical }}</p>
      <p class="my-1"><b>Skipped (manual):</b> {{ result.skippedManual }}</p>
      <p class="my-1"><b>Conflicts:</b> {{ result.conflicts?.length || 0 }}</p>
      <ul *ngIf="result.conflicts?.length" class="mt-2 pl-5 text-xs text-[#b45309]">
        <li *ngFor="let c of result.conflicts">{{ c }}</li>
      </ul>
    </div>
  </div>
</section>
